import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { hasPermission } from '../Utility/user-permission.helper';
import * as fromAuthentication from './../../shared/state/reducers';
import * as fromAuthenticationSelectors from './../state/selectors/authentication.selectors';

@Injectable({
  providedIn: 'root'
})
export class UserAuthenticatedGuard implements CanActivate {
  constructor(private store: Store<fromAuthentication.State>,
    private router: Router) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(
      select(fromAuthenticationSelectors.LoggedInUser),
      //filter( u=> )
      tap(user => {
        //console.log(user);
        if (!user) {
          this.router.navigate(['/users/login'],
            { queryParams: { return: state.url } });
        }
      }),
      map( u => !!u),
      take(1)
    );
  }

}
